var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5031_34037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6549 2.95497C21.7117 3.62032 20.6673 4.1292 19.562 4.46202C18.9688 3.77992 18.1804 3.29646 17.3035 3.07704C16.4265 2.85762 15.5033 2.91281 14.6588 3.23516C13.8142 3.55751 13.0891 4.13146 12.5813 4.87938C12.0736 5.6273 11.8078 6.51311 11.82 7.41701V8.40201C10.089 8.44689 8.37372 8.06298 6.82701 7.28447C5.2803 6.50597 3.95014 5.35702 2.95498 3.93997C2.95498 3.93997 -0.985009 12.8049 7.87996 16.7449C5.85139 18.1219 3.43483 18.8124 0.984985 18.7149C9.84996 23.6399 20.6849 18.7149 20.6849 7.38746C20.684 7.11309 20.6576 6.8394 20.6061 6.56991C21.6114 5.57851 22.3208 4.32679 22.6549 2.95497Z",
    stroke: "white",
    strokeWidth: 1.96999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5031_34037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.6399,
    height: 23.6399,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTwitter);
export default __webpack_public_path__ + "static/media/social-twitter.3233230a2cc60508095140c391ee6bad.svg";
export { ForwardRef as ReactComponent };